module.exports = __webpack_public_path__ + "static/media/COFRE_PINO_CAOBA.dfc1e3b6.png";